export default __webpack_public_path__ + "static/media/portrait.350c201e.png";